export default "__VITE_ASSET__C8Yr3_Cc__"